import React from "react";
import * as styles from "./Button.module.scss";
import classNames from "classnames";
import Icon from "../Icon";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const Button = ({
	label = "",
	type = "primary",
	big = false,
	small = false,
	disabled = false,
	callback,
	href,
	target,
	id = "",
	isSubmit = false,
	iconBefore,
	iconSize = 16,
	className,
	linkProps,
}) => {
	const buttonClassName = classNames({
		[styles["button"]]: true,
		[styles[`button--${type}`]]: !!type,
		[styles["button--big"]]: big,
		[styles["button--small"]]: small,
		[styles["button--disabled"]]: !!disabled,
		[styles["button--only-icon"]]: !!iconBefore && label === "",
		[className]: !!className,
	});

	return href && href !== "" ? (
		<Link id={id} to={href} target={target} className={buttonClassName} onClick={callback} {...linkProps}>
			{iconBefore && <Icon className={styles.iconBefore} icon={iconBefore} size={iconSize} />}
			{label !== "" && <span>{label}</span>}
		</Link>
	) : (
		<button
			id={id}
			disabled={disabled}
			type={isSubmit ? "submit" : "button"}
			className={buttonClassName}
			onClick={callback}
		>
			{iconBefore && <Icon className={styles.iconBefore} icon={iconBefore} size={iconSize} />}
			{label !== "" && <span>{label}</span>}
		</button>
	);
};

Button.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	type: PropTypes.oneOf(["primary", "secondary", "tertiary", "quaternary", "warning"]),
	big: PropTypes.bool,
	small: PropTypes.bool,
	disabled: PropTypes.bool,
	callback: PropTypes.func,
	href: PropTypes.string,
	id: PropTypes.string,
	target: PropTypes.oneOf(["_self", "_blank"]),
	isSubmit: PropTypes.bool,
	iconBefore: PropTypes.string,
	iconSize: PropTypes.number,
	className: PropTypes.string,
};

export default Button;
